export class ChatMensaje {
    fromUsuario: string;
    toUsuario: string;
    mensaje: string;
}

export class ChatUsuario {
    usuario: string;
    nombreUsuario: string;
    status: string;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/chat.ts